import { AllocationViewProfileListSearchCriteria } from '../models';

export class AllocationViewProfileListLoad {
  public static readonly type = '[AllocationViewProfileList] Load';

  constructor(public payload: AllocationViewProfileListSearchCriteria) {}
}

export class AllocationViewProfileListInitialState {
  public static readonly type = '[AllocationViewProfileList] Set Initial State';
}
